import { useEffect, useState } from "react";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputBasic from "../ProfilesComp/InputsBasic";
import InputsYorN from "../ProfilesComp/InputsYorN";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import { updateSection } from "../../../store/Profiles/profilesSlice";

const StepDental = ({ onBack, onNext }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const storedData = useSelector(state => state.profiles.Dental);
    const [dentalData, setDentalData] = useState({
        "Doestheclient": "",
        "Nowhy": "",
        "Doestheclienthavemouth": "",
        "pleasedescribe": "",
        "Doestheclienthave": "",
        "Whataffectdoestheclient": "",
        "Whatdoestheclientidentify": "",
        "Howfrequentlydoestheclient": "",
        "Iftakingmedicationshowdoes": "",
        "Whatbarriersdoestheclient": "",
        "Identifyanypastand": "",
        "Howdoestheclientrate": "",
        "Howmanymealsdoes": "",
        "Doestheclientseemtohave": "",
        "Pleasemakeanyothercomments": ""
    });

    useEffect(() => {
        setDentalData(() => ({
            ...storedData
        }));
    }, [storedData]);

    const handleChange = (key, value) => {
        setDentalData(prev => ({
            ...prev,
            [key]: typeof value === "object" && value.target ? value.target.value : value || ""
        }));
    };


    const handleNextStep = async () => {
        await handleSaveData(); // 🔹 Espera que termine antes de seguir
        onNext();
    };

    const handleSaveData = async () => {
      dispatch(updateSection({ section: "Dental", data: { Dental:dentalData } }));
    }

    return (
        <>
            <Typography variant="h5" gutterBottom>{t("Profiles.Dental.Dental")}</Typography>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormControl component="fieldset" margin="normal">
                    <FormLabel>{t("Profiles.Dental.Doestheclient")}</FormLabel>
                    <RadioGroup 
                        row 
                        value={dentalData.Doestheclient || ""} 
                        onChange={(e) => handleChange("Doestheclient", e)}
                    >
                        <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                        <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                    </RadioGroup>
                </FormControl>
                {dentalData.Doestheclient === "no" && (
                    <InputBasic 
                        Translation="Profiles.Dental.Nowhy?" 
                        value={dentalData.Nowhy || ""}  
                        onChange={(e) => handleChange("Nowhy", e)}
                    />
                )}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormControl component="fieldset" margin="normal">
                    <FormLabel>{t("Profiles.Dental.Doestheclienthavemouth/dental")}</FormLabel>
                    <RadioGroup 
                        row 
                        value={dentalData.Doestheclienthavemouth || ""} 
                        onChange={(e) => handleChange("Doestheclienthavemouth", e)}
                    >
                        <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                        <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                    </RadioGroup>
                </FormControl>
                {dentalData.Doestheclienthavemouth === "yes" && (
                    <InputBasic 
                        Translation="Profiles.Dental.pleasedescribe" 
                        value={dentalData.pleasedescribe || ""} 
                        onChange={(e) => handleChange("pleasedescribe", e)}
                    />
                )}
            </Box>

            {[
                "Doestheclienthave", 
                "Whataffectdoestheclient", 
                "Whatdoestheclientidentify", 
                "Howfrequentlydoestheclient", 
                "Iftakingmedicationshowdoes", 
                "Whatbarriersdoestheclient", 
                "Identifyanypastand"
            ].map((key) => (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                    <InputBasic 
                        key={key} 
                        Translation={`Profiles.Dental.${key}`} 
                        value={dentalData[key] || ""} 
                        onChange={(e) => handleChange(key, e)}
                    />
                </Box>
            ))}

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormLabel>{t("Profiles.Dental.Howdoestheclientrate")}</FormLabel>
                <FormControl component="fieldset" margin="normal">
                    <RadioGroup 
                        row 
                        value={dentalData.Howdoestheclientrate || ""} 
                        onChange={(e) => handleChange("Howdoestheclientrate", e)}
                    >
                        <FormControlLabel value="excellent" control={<Radio />} label={t("Profiles.Dental.excellent")} />
                        <FormControlLabel value="good" control={<Radio />} label={t("Profiles.Dental.good")} />
                        <FormControlLabel value="fair" control={<Radio />} label={t("Profiles.Dental.fair")} />
                        <FormControlLabel value="poor" control={<Radio />} label={t("Profiles.Dental.poor")} />
                    </RadioGroup>
                </FormControl>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <FormControl component="fieldset" margin="normal">
                <FormLabel component="legend">{t("Profiles.Dental.Howmanymealsdoes")}</FormLabel>
                <RadioGroup row 
                    value={dentalData.Howmanymealsdoes || ""} 
                    onChange={(e) => handleChange("Howmanymealsdoes", e)}
                >
                    <FormControlLabel value="0-1" control={<Radio />} label="0-1" />
                    <FormControlLabel value="2-3" control={<Radio />} label="2-3" />
                    <FormControlLabel value="4-5" control={<Radio />} label="4-5" />
                    <FormControlLabel value="6+" control={<Radio />} label="6+" />
                </RadioGroup>
                </FormControl>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <InputsYorN 
                    translationKey="Profiles.Dental.Doestheclientseemtohave" 
                    value={dentalData.Doestheclientseemtohave || ""} 
                    onChange={(e) => handleChange("Doestheclientseemtohave", e)}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mt: 3 }}>
                <InputBasic 
                    Translation="Profiles.Dental.Pleasemakeanyothercomments" 
                    multiline
                    value={dentalData.Pleasemakeanyothercomments || ""} 
                    rows={6}
                    onChange={(e) => handleChange("Pleasemakeanyothercomments", e)}
                />
            </Box>
            
            {/* Botones */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined">
                    {t("common.back")}
                </Button>
                <Button endIcon={<ArrowForwardIcon />} onClick={handleNextStep} variant="contained" color="primary">
                    {t("common.next")}
                </Button>
            </Box>
        </>
    );
};

export default StepDental;
